import { DATA_BUCKET_ATTR, DATA_PRIORITY_ATTR } from '../constants.js';
export function createIsomorphicStyleSheet(styleElement, bucketName, priority, elementAttributes) {
    // no CSSStyleSheet in SSR, just append rules here for server render
    const __cssRulesForSSR = [];
    elementAttributes[DATA_BUCKET_ATTR] = bucketName;
    elementAttributes[DATA_PRIORITY_ATTR] = String(priority);
    if (styleElement) {
        // eslint-disable-next-line guard-for-in
        for (const attrName in elementAttributes) {
            styleElement.setAttribute(attrName, elementAttributes[attrName]);
        }
    }
    function insertRule(rule) {
        if (styleElement === null || styleElement === void 0 ? void 0 : styleElement.sheet) {
            return styleElement.sheet.insertRule(rule, styleElement.sheet.cssRules.length);
        }
        return __cssRulesForSSR.push(rule);
    }
    return {
        elementAttributes,
        insertRule,
        element: styleElement,
        bucketName,
        cssRules() {
            if (styleElement === null || styleElement === void 0 ? void 0 : styleElement.sheet) {
                return Array.from(styleElement.sheet.cssRules).map(cssRule => cssRule.cssText);
            }
            return __cssRulesForSSR;
        },
    };
}
export function createIsomorphicStyleSheetFromElement(element) {
    const elementAttributes = Array.from(element.attributes).reduce((acc, attr) => {
        acc[attr.name] = attr.value;
        return acc;
    }, {});
    const stylesheet = createIsomorphicStyleSheet(element, elementAttributes[DATA_BUCKET_ATTR], Number(elementAttributes[DATA_PRIORITY_ATTR]), elementAttributes);
    return stylesheet;
}
//# sourceMappingURL=createIsomorphicStyleSheet.js.map